export default {
  year: 2013,
  edition: "제 9회",
  date: "2013년 11월 28일 목요일",
  time: "오후 6시 30분 ~ 9시 30분",
  location: "김대건관 K512 / 리치과학관 R914",
  links: {
    problems: {
      workbookBOJ: {
        Challenger: "https://www.acmicpc.net/workbook/view/75",
        Champion: "https://www.acmicpc.net/workbook/view/77",
      },
    },
  },
  authors: [],
  contests: [],
};
